import React, { memo } from "react";
import { EuiSpacer } from "@elastic/eui";
import PanelHeaderProps from "./PanelHeaderProps";
import "styles/components/panel/panel_header.css";

const PanelHeader: React.FC<PanelHeaderProps> = ({
  children,
  lightBorder = false,
  showBottomSpace = false,
  bottomSpaceSize = "m",
  className = "",
  showBottomBorder = true,
  borderWidth = 2,
  marginBottom,
  padding,
  style,
}) => {
  return (
    <>
      <div
        className={`panel-header-container ${`${lightBorder ? "panel-header-container--light-border" : ""}`} 
          ${!showBottomBorder ? "panel-header-container--no-bottom-border" : ""}
          ${className}
          `}
        style={
          {
            //"--panel-header-border": `${borderWidth}px solid var(--block-border-color)`,
            ...(marginBottom && { "margin-bottom": `${marginBottom}px` }),
            ...(padding && { padding: `${padding}px` }),
            position: "relative",
            ...style,
          } as React.CSSProperties
        }>
        {children}
      </div>

      {showBottomSpace && <EuiSpacer size={bottomSpaceSize} />}
    </>
  );
};

export default memo(PanelHeader);
